import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Menu } from "primereact/menu";
import { confirmDialog } from "primereact/confirmdialog";
import { InputComponent } from "../InputComponent";
import { TablaDinamica } from "../TablaDinamica";
import * as generic from "../Generico";
import { useLazyParams } from "../../hooks/useLazyParams";
import { CertificacionAdicional } from "../../models/trust/cliente/CertificacionAdicional";
import { ControlService } from "../../service/trust/certificacion/ControlService";

export const SociedadControl = ({ toast, id, catalogos, permss, soloLectura }) => {

    const omodel = new CertificacionAdicional();
    const defaultValues = generic.funDefault(omodel.model, null);

    const [dialogVisible, setDialogVisible] = useState(false);
    const [registroSeleccionado, setRegistroSeleccionado] = useState(null);
    const menuRef = useRef(null);

    const controlSrv = new ControlService();
    const tablaControl = useLazyParams({ modelo: omodel.model });

    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const { inText, inDrop } = InputComponent({ omodel, errors, control, permss, id: getValues('id'), soloLectura });

    useEffect(() => {
        if (id) loadLazyData();
        // eslint-disable-next-line
    }, [tablaControl.lazyParams, id]);

    const loadLazyData = () => {
        tablaControl.setLoading(true);
        const _params = { ...tablaControl.lazyParams, idp: id };
        controlSrv.getLista({ lazyEvent: JSON.stringify(_params) }).then(res => {
            tablaControl.setTotalRecords(res.data.total);
            tablaControl.setData(res.data.registros);
        }).finally(() => tablaControl.setLoading(false));
    };

    const openNew = () => {
        reset(defaultValues);
        setDialogVisible(true);
    };

    const hideDialog = () => setDialogVisible(false);

    const onSubmit = (data) => {
        data.idp = id;

        const request = getValues('id') == null
            ? controlSrv.nuevo(data)
            : controlSrv.editar(data);

        request.then(res => {
            setDialogVisible(false);
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => generic.funcError(error, toast, setError));
    };

    const editRegistro = (idReg) => {
        controlSrv.consultar(idReg).then(res => {
            const _data = res.data.certificacion_persona_control;
            reset(generic.renewValues(_data, omodel.model));
            setDialogVisible(true);
        });
    };

    const confirmDelete = (idReg) => {
        confirmDialog({
            message: '¿Está seguro de eliminar esta persona de control?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                controlSrv.eliminar(idReg).then(res => {
                    loadLazyData();
                    generic.funcSuccess(res, toast);
                }).catch(error => generic.funcDeleteError(error, toast));
            }
        });
    };

    const itemsMenu = () => {
        if (soloLectura) {
            return [{
                label: 'Opciones',
                items: [{ label: 'Ver detalle', icon: 'pi pi-eye', command: () => editRegistro(registroSeleccionado?.id) }]
            }];
        }
        return [{
            label: 'Opciones',
            items: [
                { label: 'Editar', icon: 'pi pi-pencil', command: () => editRegistro(registroSeleccionado?.id) },
                { label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete(registroSeleccionado?.id) }
            ]
        }];
    };

    const accionesTemplate = (rowData) => (
        <Button
            icon="pi pi-caret-down"
            type="button"
            className="p-button-rounded p-button-success mr-2"
            title="Opciones/Acciones"
            aria-controls="popup_menu_sociedad_control"
            aria-haspopup
            onClick={(e) => { setRegistroSeleccionado(rowData); menuRef.current.toggle(e); }}
        />
    );

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '4rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );

    const cabeceraTabla = () => (
        <div className="flex align-items-center justify-content-start gap-3 py-1">
            {permss?.crear && id && !soloLectura && (
                <Button icon="pi pi-plus" className="p-button-success p-button-sm" type="button" onClick={openNew} />
            )}
            <span className="text-sm font-semibold text-600 uppercase tracking-wider">
                Listado de Personas que Ejercen el Control
            </span>
        </div>
    );

    return (
        <div className="componente-sociedad-control">
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu_sociedad_control" />
            <TablaDinamica modelo={omodel.model} estadoTabla={tablaControl} datos={tablaControl.data} totalRegistros={tablaControl.totalRecords} dataKey="id" acciones={ColumnaAcciones} header={cabeceraTabla()} />

            <Dialog visible={dialogVisible} header={getValues('id') == null ? "Nueva Persona de Control" : "Editar Persona de Control"} modal className="p-fluid modal-ssize dialog-personalizado" onHide={hideDialog} style={{ width: '600px' }}>
                <form onSubmit={(e) => { e.stopPropagation(); handleSubmit(onSubmit)(e); }}>
                    <div className="formgrid grid px-2">

                        {inText('razon_social', { icon: 'pi pi-building' }, 12)}
                        {inDrop('tipo_identificacion', catalogos?.tipo_identificacion, { lab: 'nombre' }, 6)}
                        {inText('identificacion', { icon: 'pi pi-id-card' }, 6)}
                        {inDrop('estatus', catalogos?.estatus_control, { lab: 'nombre' }, 12)}

                        <div className="col-12 mt-4 flex justify-content-end">
                            {soloLectura ? (
                                <div className="field col">
                                    <Button label="Cerrar" style={{ maxWidth: '120px' }} icon="pi pi-times" type="button" className="p-button-warning" onClick={hideDialog} />
                                </div>
                            ) : (
                                generic.buttonsForms(hideDialog)
                            )}
                        </div>

                    </div>
                </form>
            </Dialog>
        </div>
    );
};
